const n = "_info_28jlu_1", t = "_hasLeftComponent_28jlu_7", e = "_textContainer_28jlu_11", o = "_headerContainer_28jlu_16", a = {
  info: n,
  hasLeftComponent: t,
  textContainer: e,
  headerContainer: o
};
export {
  a as default,
  t as hasLeftComponent,
  o as headerContainer,
  n as info,
  e as textContainer
};
//# sourceMappingURL=index.es5746.js.map
